import { forwardRef, createElement } from 'react';
import { extractAtomsFromProps, composeClassNames } from '@dessert-box/core';

function createBox({
  atoms: atomsFn,
  defaultClassName
}) {
  const Box = /*#__PURE__*/forwardRef(({
    as: element = 'div',
    className,
    style,
    ...props
  }, ref) => {
    const {
      atomProps,
      customProps,
      otherProps
    } = extractAtomsFromProps(props, atomsFn);
    return /*#__PURE__*/createElement(element, {
      ref,
      style: { ...style,
        ...customProps
      },
      ...otherProps,
      className: composeClassNames(className, atomsFn(atomProps), defaultClassName)
    });
  });
  Box.displayName = 'DessertBox';
  return Box;
}
function createBoxWithAtomsProp({
  atoms: atomsFn,
  defaultClassName
}) {
  const Box = /*#__PURE__*/forwardRef(({
    as: element = 'div',
    className,
    atoms,
    ...props
  }, ref) => {
    return /*#__PURE__*/createElement(element, {
      ref,
      ...props,
      className: composeClassNames(className, atomsFn(atoms), defaultClassName)
    });
  });
  Box.displayName = 'DessertBox';
  return Box;
}

export { createBox, createBoxWithAtomsProp };
